import { render, staticRenderFns } from "./RequestDocumentationTemplate.vue?vue&type=template&id=6c284d8b&"
import script from "./RequestDocumentationTemplate.vue?vue&type=script&lang=js&"
export * from "./RequestDocumentationTemplate.vue?vue&type=script&lang=js&"
import style0 from "./RequestDocumentationTemplate.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports